import { useEffect } from "react";
import { LoadingPanels } from "app/components/analytics/shared/LoadingStates";
import { Build } from "app/components/build/Show/lib/types";
import { CommandJob } from "app/components/build/Show/lib/types/CommandJob";

type Props = {
  build: Build;
  job?: CommandJob;
};

export default function V2TestEngine({ build, job }: Props) {
  const url = job ? job.testEngine.testTabUrl : build.testEngine.testTabUrl;
  const frameId = `te_tests${job ? `_${job.id}` : ""}`;

  useEffect(() => {
    const handler = (event) => {
      if (event.target.id === frameId) {
        localStorage.setItem("hide-test-tab-pill", "true");
      }
    };

    document.addEventListener("turbo:frame-load", handler);
    return () => document.removeEventListener("turbo:frame-load", handler);
  }, [frameId]);

  return (
    <div data-turbo="true">
      {url ? (
        <turbo-frame
          className="w-full h-full"
          id={frameId}
          src={url}
          data-executions={true}
          data-controller="error"
          data-action="turbo:frame-missing->error#handleTurboFrameMissing"
        >
          <div className="p-4">
            <LoadingPanels rows={10} columns={1} />
          </div>
        </turbo-frame>
      ) : (
        <div className="flex flex-col items-center justify-center gap-3 p-5 rounded min-h-[320px] bg-slate-100">
          <span className="text-3xl leading-none text-center emoji">🤖</span>
          <div className="flex flex-col items-center justify-center gap-2">
            <h3 className="text-xl m-0">The requested data could not be found.</h3>
          </div>
          <p className="text-center leading-normal m-0">
            Try refreshing the page; if the problem persists
            <a href="mailto:support@buildkite.com" className="text-green-600 hover:underline">
              {" "}
              let us know.
            </a>
          </p>
        </div>
      )}
    </div>
  );
}
